import memoize from 'memoize-one';

export const parseSearch = memoize((search) => {
  const queryParams = new URLSearchParams(search);
  const query = {};

  for (const [param, value] of queryParams) {
    if (!query[param]) {
      query[param] = value;
    } else if (Array.isArray(query[param])) {
      query[param] = [...query[param], value];
    } else {
      query[param] = [query[param], value];
    }
  }

  return query;
});
